const galleryItemSelector = '.js-mobile-pswp-item.is-always-visible';

export const getGalleryItems = (gallery) => (gallery ? Array.from(gallery.querySelectorAll(galleryItemSelector)) : []);

export const getPrecedingContentLayoutGallery = (shiftImagesGallery) => {
    const shiftImagesSection = shiftImagesGallery?.closest('section');
    const precedingSection = shiftImagesSection?.previousElementSibling;

    if (!precedingSection?.matches('section')) {
        return null;
    }

    return precedingSection.querySelector('.content-layout__images.js-mobile-pswp-gallery');
};

export const getFollowingShiftImagesGallery = (contentLayoutGallery) => {
    const contentLayoutSection = contentLayoutGallery?.closest('section');
    const followingSection = contentLayoutSection?.nextElementSibling;

    if (!followingSection?.matches('section')) {
        return null;
    }

    return followingSection.querySelector('.shift-images.js-mobile-pswp-gallery');
};
